require("./heatmap/HeatmapSeries");

require("./heatmap/HeatmapView");


//////////////////
// WEBPACK FOOTER
// ./node_modules/echarts/lib/chart/heatmap.js
// module id = o0k+
// module chunks = 0 1